import { EventManager } from './core/events/event-manager.ts';
import { modulesProvider } from './core/providers/modules.ts';
import { Logger } from './core/helpers/logger.ts';
import { prescript } from './core/providers/prescript.ts';
import { storeManager } from './core/store/store-manager.ts';
import { api } from './core/api/client.ts';

// window.FashionHintPrescript = () => ({
// 	getModules(): string[] {
// 		return ['similar', 'complementary', 'commonEvents'];
// 	},
//
// 	getTenantId: () => {
// 		return 6014;
// 	},
//
// 	getCollectionName: () => {
// 		return 'be-urban-v2';
// 	},
//
// 	getPermalink: () => {
// 		return 'https://beurbanrunning.com/en/products/hq0620_133';
// 	},
//
// 	getLang: () => {
// 		return 'en';
// 	},
//
// 	getPerPage: () => {
// 		return 8;
// 	},
//
// 	getBaseVrfUrl() {
// 		return 'https://vfr-v3-production.sizebay.technology/';
// 	},
//
// 	getBaseFashionHintUrl() {
// 		return 'https://fashion-hint.internalsizebay.com/';
// 	},
//
// 	getSizeSystem() {
// 		return 'EU';
// 	},
//
// 	getEnvironment() {
// 		return 'production';
// 	},
//
// 	getCurrency() {
// 		return 'EUR';
// 	},
//
// 	getDefaultUnit() {
// 		return 'cm';
// 	},
//
// 	getSimilarContainerId() {
// 		return 'fashion-hint-similar';
// 	},
//
// 	getComplementaryContainerId() {
// 		return 'fashion-hint-complementary';
// 	},
//
// 	getSimilarityThreshold() {
// 		return 0.1;
// 	},
// });

async function ensureSessionId(): Promise<string | undefined> {
	try {
		if (storeManager.getCookie('SIZEBAY_SESSION_ID_V4')) return;
		const response = await api.get(`${prescript.baseVrfUrl}api/me/session-id`);

		storeManager.setCookie({
			name: 'SIZEBAY_SESSION_ID_V4',
			value: response.data,
		});

		return response.data;
	} catch (error) {
		Logger.error('Error fetching session ID:', error);
		return undefined;
	}
}

async function bootstrap() {
	const eventManager = new EventManager();

	await ensureSessionId();

	const { modules } = prescript;
	await modulesProvider.load(modules);

	eventManager.publish('app:ready', { loadedModules: modules });
}

bootstrap().then(() => Logger.info('App inicializada com sucesso.'));
